function getPersistentUrl(path) {
    return `${Q3.s3Url}/persistent_assets/${path ? path : ""}`;
}

export default getPersistentUrl;
export { getPersistentUrl };